import { Component } from '@angular/core';

@Component({
  selector: 'app-detail-prestation-hospit',
  imports: [],
  templateUrl: './detail-prestation-hospit.component.html',
  styleUrl: './detail-prestation-hospit.component.scss'
})
export class DetailPrestationHospitComponent {

}
